module.exports = __webpack_public_path__ + "static/media/mitsubishi-plus.aded7631.svg";